/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object"

// ============ TYPES ============
export interface ProductUserLikeCreatePayload {
  brand_token: string
  product_id: number
  user_id: number
}

export default ($axios: any) => ({
  // Brand with specific product likes user (influencer/model)
  async store(data: ProductUserLikeCreatePayload) {
    const response = await $axios.post(`/product-user-like`, snakelize(data))
    return camelize(response)
  },

  // Brand with specific product unlikes user (influencer/model)
  async delete(id: number, brandToken: string) {
    const response = await $axios.delete(`/product-user-like/${id}`, {
      data: { brand_token: brandToken }
    })
    return camelize(response)
  },
})
